
import {
  Vue, Component, Watch,
} from 'vue-property-decorator';
import {
  Getter, Mutation,
} from 'vuex-class';
import Constants from '@/assets/ts/configuration/Constants';
import TheNavBar from '../bower_components/teknisavuecomponents/components/sections/TheNavBar.vue';
import TheFooter from '../bower_components/teknisavuecomponents/components/sections/TheFooter.vue';
import TheLoadingAnimation from '../bower_components/teknisavuecomponents/components/animations/TheLoadingAnimation.vue';
import SnackbarUtils from '../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';

import { User, Periodo } from '../bower_components/teknisavuecomponents/assets/interfaces/interfaces';
import SelectPeriodoComponent from './components/SelectPeriodoComponent.vue';
import SelectEstruturaComponent from './components/SelectEstruturaComponent.vue';
import TkDialog from '../bower_components/teknisavuecomponents/components/popups/TkDialog/TkDialog.vue';
import DialogUtils from '../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import TkPopup from '@/components/TkPopup/TkPopup.vue';
import ApuracaoController from '@/assets/ts/controller/ApuracaoController';

@Component({
  name: 'App',
  components: {
    TheNavBar,
    TheFooter,
    TheLoadingAnimation,
    TkDialog,
    SelectPeriodoComponent,
    SelectEstruturaComponent,
    TkPopup,
  },
})
class App extends Vue {
  private productVersion = Constants.PRODUCT_VERSION;

  @Getter('loadingVisibility')
  private loadingVisibility: boolean;

  @Getter('user')
  private user: User;

  @Getter('viewName')
  private currentView: User;

  @Getter('finishedLoadingInfo')
  private finishedLoadingInfo: any;

  @Getter('estruturasGerenciais')
  private estruturasGerenciais: any[];

  @Getter('notifications')
  private notifications: any;

  @Getter('periodosDemonstrativo')
  private periodosDemonstrativo: any[];

  @Getter('loadingIsForceHidden')
  private loadingIsForceHidden: boolean;

  @Getter('loadingProgressPercentage')
  private loadingProgressPercentage: number;

  @Getter('loadingIsIndeterminate')
  private loadingIsIndeterminate: boolean;

  @Getter('loadingAppendedText')
  private loadingAppendedText: string;

  @Getter('loadingCancelVisible')
  private loadingCancelVisible: boolean;

  @Mutation('updateProductVersion')
  private updateProductVersion: (version: string) => void;

  @Mutation('setNotificationsAsRead')
  private setNotificationsAsRead: () => void;

  // LIFECYCLE
  private created(): void {
    const toast = (this as any).$toast;
    SnackbarUtils.toast = toast;

    const version = Constants.PRODUCT_VERSION;
    this.updateProductVersion(version);
  }

  private mounted() {
    const dialog = (this as any).$refs.dialog;

    (window as any).showDialog = dialog.show;
    (window as any).hideDialog = dialog.hide;
    DialogUtils.init();

    this.setBreakpointClass();
  }

  @Watch('finishedLoadingInfo')
  private finishedLoadingInfoOnChange() {
    if (this.estruturasGerenciais.length === 0) {
      SnackbarUtils.showMessage('Nenhuma unidade é gerida por você.', 'alert', 6000);
    }

    if (this.periodosDemonstrativo.length === 0) {
      SnackbarUtils.showMessage('Nenhum período encontrado.', 'alert', 6000);
    }
  }

  @Watch('breakpoint')
  private breakpointOnChange() {
    this.setBreakpointClass();
  }

  // #region [ COMPUTED ]
  private get qtNotifications(): number {
    const quantity = this.notifications.messages.length;

    return quantity;
  }

  private get newNotifications(): boolean {
    const thereAreNew =
      this.notifications.messages.length > 0 &&
      !this.notifications.read;

    return thereAreNew;
  }

  private get breakpoint(): string {
    return this.$vuetify.breakpoint.name;
  }

  private get isLoading(): boolean {
    return !this.loadingIsForceHidden && this.loadingVisibility;
  }
  // #endregion

  // #region [ METHODS ]
  private notificationButtonOnClick() {
    if (!this.newNotifications) {
      SnackbarUtils.showMessage('Não há notificações novas.', 'alert');
      (this as any).$toast.clearQueue();
    } else {
      this.showNotifications(this.notifications.messages);
      this.setNotificationsAsRead();
    }
  }

  private showNotifications(messages: string[]) {
    messages.forEach((msg) => {
      SnackbarUtils.showMessage(msg, 'info2', 6000);
    });
  }

  private setBreakpointClass() {
    const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];
    const app = <HTMLElement>document.getElementById('app');

    if (!app) {
      return;
    }

    app.classList.remove(...breakpoints);
    app.classList.add(this.breakpoint);
  }

  private loadingActionOnClick() {
    ApuracaoController.forceStopOperacao();
  }
  // #endregion
}

export default App;
